import addDuration from './add-duration';
import toDate from './to-date';

export default function floorDate(date, unit, weekStartDay) {
    return addDuration(toDate(date), 0, unit, weekStartDay);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/date-utils/floor-date.js
// module id = 967
// module chunks = 29